











import Footer from '@/components/page/Footer.vue';
import Nav from '@/components/page/Nav.vue';
import HealthQuery from '@/graphql/queries/health.gql';
import request, { API_HOST } from '@/graphql/request';
import 'aos/dist/aos.css';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Nav,
    Footer,
  },
})
export default class App extends Vue {
  public isApiOnline = true;

  public mounted() {
    import('aos').then(aos => aos.init());
    document.title = 'Remeco Care';
    this.checkApiStatus();
  }

  public created() {
    const fa = document.createElement('script');
    fa.setAttribute(
      'src',
      'https://use.fontawesome.com/releases/v5.0.7/js/all.js'
    );
    document.head.appendChild(fa);
  }

  private async checkApiStatus() {
    const status = request(HealthQuery)
      .then(response => {
        if (response.data.health.length > 0) {
          this.isApiOnline = true;
        }
      })
      .catch(() => {
        this.isApiOnline = false;
      });
  }
}
